import axios from "../api";

export const fetchPermissionMatrixApi = () => axios.get("/permissions");

export const updatePermissionMatrixApi = (permissionMatrix) =>
  axios.put("/permissions", { permissionMatrix });

export const initPermissionMatrixApi = () =>
  axios.post("/permissions/init");
